<template>
  <div>
    <CardWithImageAndButton
    title="Сервис поиска устройств IoT"
    text="
    Основное назначение сервиса — быстрое и точное выявление уязвимых устройств, таких как веб-камеры, маршрутизаторы, умные датчики и другая подключённая техника, незащищённая или неправильно сконфигурированная.
    <br /><br />
    В основе системы — мощный краулер и гибкий диспетчер обкачки, которые в автоматическом режиме сканируют адресное пространство, обнаруживают подключённые устройства, анализируют типы используемых протоколов и формируют индекс с возможностью последующего поиска.
    <br /><br />
    Используемые технологии: Go, JavaScript.
    "
    :imagePath="require('../../assets/imgs/search-for-device.png')"
    imagePosition="left"
    :buttonIsVisible="false"
    />
    <List :items="listItems" title="Что мы предлагаем" theme="dark" />
  </div>
</template>

<script>
import { CardWithImageAndButton, List } from 'sputnik-ui/src/index';
export default {
  name: 'SearchForDevicesPage',
  components: {
    CardWithImageAndButton,
    List
  },
  data() {
    return {
      listItems: [
        {text: "Поиск устройств"},
        {text: "Диспетчер обкачки и краулер"},
        {text: "Индексирование"},
        {text: "Пользовательский интерфейс простого поиска"},
        {text: "Анализ протоколов"},
        {text: "Возможность проверки подключения"},
      ]
    };
  },
};
</script>
